import { mergeRight, pluck } from "ramda"
import { defaultDeviceDataSyncAttributes } from "js/includes/configuration/psa/ConnectWise/settings/ConnectWiseConfigurationTypes/DeviceDataSyncAttributes/defaultAttributes"

export const initialState = {
  deviceDataSyncAttributes: pluck("value", defaultDeviceDataSyncAttributes),
}

export default function settings(state = initialState, action) {
  switch (action.type) {
    case "SET_CW_SETTINGS":
      return action.payload
    case "SET_CW_DEVICE_DATA_SYNC_ATTRIBUTES":
      return mergeRight(state, { deviceDataSyncAttributes: action.attributes })
    default:
      return state
  }
}
